import { inject } from 'vue'
import { PageContextKey } from './constants'

export const usePage = () => inject(PageContextKey, {})
